<template>
  <div class="row detalhe-group-despesa">
    <public-header :title="title">
      <ano-base />
      <div class="col-sm-6">
        <p>
          A Unidade Orçamentária
          <span class="destaque-header">"{{ gastosNivel1.descricao }}"</span>,
          para o ano de <span class="destaque-header">{{ ano_base }}</span>
          possui uma previsão de gastos no valor de
          <span class="destaque-header">{{
            formatarMoeda(Number(gastosNivel1.vl_previsto))
          }}</span
          >, sendo autorizado um valor total de gastos de
          <span class="destaque-header">{{
            formatarMoeda(Number(gastosNivel1.vl_autorizado))
          }}</span>
        </p>
        <p>
          Do valor total, até o mês de
          <span class="destaque-header">{{ mes_base.nome }}</span
          >, foram efetuados os seguintes valores:
        </p>
        <ul>
          <li>
            <span class="destaque-header">
              Empenho:
              {{ formatarMoeda(Number(gastosNivel1.vl_empenhado_acu)) }} ({{
                gastosNivel1.vl_empenhado_perc
              }})
            </span>
          </li>
          <li>
            <span class="destaque-header">
              Liquidação:
              {{ formatarMoeda(Number(gastosNivel1.vl_liquidado_acu)) }} ({{
                gastosNivel1.vl_liquidado_perc
              }})
            </span>
          </li>
          <li>
            <span class="destaque-header">
              Pagamento:
              {{ formatarMoeda(Number(gastosNivel1.vl_pago_acu)) }} ({{
                gastosNivel1.vl_pago_perc
              }})
            </span>
          </li>
        </ul>
      </div>
      <div class="col-sm-6">
        <bar-chart
          ref="despesa_empenho"
          :chart-data="graficoDespesa"
          :gradiente="false"
          :coloredLine="true"
          :options="graficoOptions"
        ></bar-chart>
      </div>
    </public-header>
    <div class="container">
      <div class="row">
        <ol class="breadcrumb">
          <li><router-link :to="'/'">Início</router-link></li>
          <li>
            <router-link :to="'/receitas_despesas'"
              >Receitas e Despesas</router-link
            >
          </li>
          <li><router-link :to="'/despesas'">Despesas</router-link></li>
          <li>{{ title }}</li>
        </ol>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h3>Unidades Executoras</h3>
        </div>
      </div>
      <div class="row">
        <card :data="listaCards()" />
      </div>
      <div class="row margem-bottom">
        <div class="col-xs-12">
          <h3>
            Todas as Despesas
          </h3>
        </div>
        <div class="col-xs-12 col-sm-6">
          <label for="descricao">Histórico</label>
          <input
            name="descricao"
            placeholder="Digite um texto para filtrar..."
            type="text"
            v-model="filtros.descricao"
            class="form-control"
          />
        </div>
      </div>
      <div class="totais-despesa">
        <span>
          <strong>Empenhado:</strong>
          {{ formatarMoeda(totalDespesasFiltradas.vl_empenhado) }}
        </span>
        <span>
          <strong>Liquidado:</strong>
          {{ formatarMoeda(totalDespesasFiltradas.vl_liquidado) }}
        </span>
        <span>
          <strong>Pago:</strong>
          {{ formatarMoeda(totalDespesasFiltradas.vl_pago) }}
        </span>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <data-table
            :dados="despesasUnidade"
            :fields="fields"
            :carregando="isLoading"
          >
            <template slot="columncustom" slot-scope="props">
              {{
                `${props.rowData.nr_doc_despesa}/${props.rowData.ano_doc_despesa}`
              }}
            </template>
            <template slot="rowrender" slot-scope="props">
              <button class="btn btn-primary" @click="montarEmpenho(props)">
                <font-awesome-icon :icon="'search'" /><span class="sr-only"
                  >Detalhes</span
                >
              </button>
            </template>
          </data-table>
        </div>
      </div>
    </div>
    <side-bar :sides="navs">
      <template :slot="navs[0].identidade">
        <div class="side-body">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Data Despesa:</label>
              {{
                new Date(
                  `${detalhe_empenho['dt_doc_despesa']} 00:00:00`
                ).toLocaleDateString()
              }}
            </div>
            <div class="col-xs-12 col-sm-6">
              <label>Credor:</label> {{ detalhe_empenho['credor'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Valor Empenhado:</label>
              {{ detalhe_empenho['vl_empenhado'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Valor Liquidado:</label>
              {{ detalhe_empenho['vl_liquidado'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Valor Pago:</label> {{ detalhe_empenho['vl_pago'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Unid. Orçamentária:</label>
              {{ detalhe_empenho['unidade_orcamentaria'] }}
            </div>
            <div class="col-xs-12 col-sm-6">
              <label>Unid. Executora:</label>
              {{ detalhe_empenho['unidade_executora'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Função:</label> {{ detalhe_empenho['funcao'] }}
            </div>
            <div class="col-xs-12 col-sm-6">
              <label>Subfunção:</label> {{ detalhe_empenho['subfuncao'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Programa:</label> {{ detalhe_empenho['programa'] }}
            </div>
            <div class="col-xs-12 col-sm-6">
              <label>Ação:</label> {{ detalhe_empenho['acao'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Subelemento:</label> {{ detalhe_empenho['subelemento'] }}
            </div>
            <div class="col-xs-12 col-sm-6">
              <label>Fonte Recurso:</label>
              {{ detalhe_empenho['fonte_recurso'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Aplicação:</label> {{ detalhe_empenho['aplicacao'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Tipo:</label> {{ detalhe_empenho['tipo'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Regime:</label> {{ detalhe_empenho['regime'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Centro de Custo:</label>
              {{ detalhe_empenho['centro_custo'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Tipo Despesa:</label> {{ detalhe_empenho['tipo_despesa'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Processo Despesa:</label>
              {{ detalhe_empenho['processo_despesa'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Licitação:</label> {{ detalhe_empenho['licitacao'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Contrato:</label> {{ detalhe_empenho['contrato'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Tipo Contrato:</label>
              {{ detalhe_empenho['tipo_contrato'] }}
            </div>
            <div class="col-xs-12 col-sm-6 col-md-4">
              <label>Subtipo Contrato:</label>
              {{ detalhe_empenho['subtipo_contrato'] }}
            </div>
            <div class="col-xs-12 col-sm-6">
              <label>Objeto Contrato:</label>
              {{ detalhe_empenho['objeto_contrato'] }}
            </div>
          </div>
          <hr />
          <div class="row lista-head">
            <div class="col-xs-12 col-sm-2">
              Tipo Movimentação
            </div>
            <div class="col-xs-12 col-sm-2">
              Data
            </div>
            <div class="col-xs-12 col-sm-2">
              Valor
            </div>
            <div class="col-xs-12 col-sm-6">
              Descrição
            </div>
          </div>
          <div
            v-for="(item, index) in historico_empenho.empenhos"
            :key="item.id_doc_despesa"
            :class="[index % 2 !== 0 ? '' : 'lista-impar', 'row']"
          >
            <div class="col-xs-12 col-sm-2">
              {{ item['tp_movimento'] }}
            </div>
            <div class="col-xs-12 col-sm-2">
              {{
                new Date(
                  `${item['dt_movimento']} 00:00:00`
                ).toLocaleDateString()
              }}
            </div>
            <div class="col-xs-12 col-sm-2">
              {{ item['vl_movimento'] }}
            </div>
            <div class="col-xs-12 col-sm-6">
              {{ item['historico'] }}
            </div>
          </div>
        </div>
      </template>
    </side-bar>
  </div>
</template>

<script>
import { BarChart, PublicHeader, PieChart, AnoBase } from '@/components/common/'
import { formatarMoeda, contains, desformatarMoeda } from '@/utils/strings.js'
import colors from '@/utils/colors.js'
import Card from '../Card.vue'
import SideBar from '@/components/common/side-modal'
import { request } from '@/request'
import DataTable from '@/components/common/NoApiTable'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    PublicHeader,
    PieChart,
    Card,
    BarChart,
    SideBar,
    DataTable,
    AnoBase
  },
  data() {
    return {
      filtros: {
        descricao: ''
      },
      title: '',
      operacao: '',
      detalhe_empenho: {},
      historico_empenho: [],
      items: [],
      navs: [
        {
          titulo: 'Adiantamentos',
          subtitulo: 'Detalhes do empenho',
          subtDetalhe: '',
          largura: 1200,
          identidade: 'aditamento',
          abreProximo: true,
          aberto: false
        }
      ],
      graficoOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Acompanhamento de receitas',
          fontColor: '#C1D1C1'
        },
        legend: {
          display: true,
          labels: {
            fontColor: '#C1D1C1'
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                suggestedMax: 50,
                fontColor: '#C1D1C1',
                callback: function(value, index, values) {
                  return value.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL'
                  })
                }
              }
            }
          ],
          xAxes: [
            {
              maxBarThickness: 50,
              ticks: {
                fontColor: '#C1D1C1'
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            label: function(tooltip, dataset) {
              var xLabel = dataset.datasets[tooltip.datasetIndex].label
              var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL'
              })
              return xLabel + ': ' + yLabel
            }
          }
        }
      },
      graficos_base: {
        labels: [],
        datasets: [{ label: '', backgroundColor: [], data: [] }]
      },
      url_geosiap_base:
        'https://geosiap.santos.sp.gov.br/portal-transparencia/api/default/execucao/despesas_detalhadas',
      fields: [
        {
          name: '__slot:column',
          title: 'Empenho'
        },
        {
          name: 'dt_doc_despesa',
          title: 'Data',
          callback(value) {
            return new Date(`${value} 00:00:00`).toLocaleDateString()
          }
        },
        {
          name: 'historico',
          title: 'Histórico'
        },
        {
          name: 'vl_empenhado',
          title: 'Empenhado',
          titleClass: 'text-right',
          dataClass: 'text-right'
        },
        {
          name: 'vl_liquidado',
          title: 'Liquidado',
          titleClass: 'text-right',
          dataClass: 'text-right'
        },
        {
          name: 'vl_pago',
          title: 'Pago',
          titleClass: 'text-right',
          dataClass: 'text-right'
        },
        {
          name: '__slot:actions',
          title: 'Visualizar',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }
      ]
    }
  },
  created() {
    const { operacao } = this.$route.params
    this.operacao = operacao

    switch (operacao) {
      case 'ue':
        const { grupo_despesas } = this.$store.state.receitas_despesas
        this.loadGrupoDespesas(grupo_despesas)
        break
      case 'fs':
        const { funcao_subfuncao } = this.$store.state.receitas_despesas
        this.loadGrupoDespesas(funcao_subfuncao)
        break
    }
  },
  computed: {
    ...mapState({
      ano_base: state => state.receitas_despesas.ano_base
    }),
    ...mapGetters(['isLoading']),
    mes_base() {
      const data = new Date()
      if (this.ano_base !== data.getFullYear()) {
        const val = new Date(this.ano_base, 11, 31)
        return {
          nome: val.toLocaleString('default', { month: 'long' }),
          valor: val.getMonth()
        }
      }

      return {
        nome: data.toLocaleString('default', { month: 'long' }),
        valor: data.getMonth()
      }
    },
    totalDespesasFiltradas() {
      const reducer = (acumulador, atual) => {
        acumulador.vl_empenhado += this.desformatarMoeda(atual.vl_empenhado)
        acumulador.vl_liquidado += this.desformatarMoeda(atual.vl_liquidado)
        acumulador.vl_pago += this.desformatarMoeda(atual.vl_pago)

        return acumulador
      }

      let base = {
        vl_empenhado: 0,
        vl_liquidado: 0,
        vl_pago: 0
      }

      if (!this.despesasUnidade.length) return base

      return this.despesasUnidade.reduce(reducer, base)
    },
    despesasUnidade() {
      const { despesas_detalhadas } = this.$store.state.receitas_despesas
      const { descricao } = this.$route.params

      const filter = item => {
        if (
          item.funcao.substring(0, descricao.length) === descricao ||
          item.unidade_orcamentaria.substring(0, descricao.length) === descricao
        ) {
          return true
        }

        return false
      }

      const despesas = despesas_detalhadas.filter(filter)

      if (this.filtros.descricao) {
        return this.filtrar(despesas)
      }

      return despesas
    },
    carregandoDespesas() {
      const { despesas_detalhadas } = this.$store.state.receitas_despesas

      if (despesas_detalhadas.length) {
        return false
      }

      return true
    },
    gastosNivel1() {
      if (this.items.length === 0) {
        return {}
      }

      const [first] = this.items
      return first
    },
    gastosNivel2() {
      return this.items.slice(1)
    },
    graficoDespesa() {
      const labels = ['Empenho', 'Liquidação', 'Pagamento']

      return {
        ...this.graficos_base,
        labels,
        datasets: [
          {
            type: 'line',
            label: `Previsão Anual - ${this.ano_base}`,
            backgroundColor: colors.coresHexa[0],
            borderColor: colors.coresHexa[0],
            fill: false,
            data: Array(3).fill(this.gastosNivel1.vl_previsto)
          },
          {
            label: `Acumulado - ${this.ano_base}`,
            backgroundColor: colors.coresHexa[1],
            data: [
              this.gastosNivel1.vl_empenhado_acu,
              this.gastosNivel1.vl_liquidado_acu,
              this.gastosNivel1.vl_pago_acu
            ]
          }
        ]
      }
    }
  },
  methods: {
    filtrar(lista) {
      const filter = obj => {
        if (this.filtros.descricao !== '') {
          return this.contains(obj.historico, this.filtros.descricao)
        }

        return true
      }

      return lista.filter(filter)
    },
    montarEmpenho(item) {
      const { ano_doc_despesa, nr_doc_despesa } = item.rowData
      this.abrir(`${nr_doc_despesa}/${ano_doc_despesa}`, 'Despesa')
    },
    formatarMoeda,
    desformatarMoeda,
    contains,
    abrir(empenho, title) {
      this.navs[0].titulo = title
      this.navs[0].subtDetalhe = `Empenho nº: ${empenho}`
      this.carregarDetalhesEmpenho(empenho)
      this.$emit('abreModal', this.navs[0].identidade)
    },
    carregarDetalhesEmpenho(empenho) {
      const emp = empenho.split('/')
      const filter = obj => {
        if (obj.ano_doc_despesa === emp[1] && obj.nr_doc_despesa === emp[0]) {
          return true
        }
        return false
      }

      const { despesas_detalhadas } = this.$store.state.receitas_despesas

      this.detalhe_empenho = despesas_detalhadas.filter(filter)[0]
      this.carregarHistoricoEmpenho(this.detalhe_empenho.id_doc_despesa)
    },
    carregarHistoricoEmpenho(idEmpenho) {
      this.historico_empenho = []

      request
        .get(
          `${
            this.url_geosiap_base
          }/empenhos?ano=${new Date()}&data_inicial=undefined&data_final=undefined&id_entidade=1&id_empenho=${idEmpenho}`
        )
        .then(response => {
          this.historico_empenho = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    listaCards() {
      let data = []

      for (let index = 0; index < this.gastosNivel2.length; index++) {
        const element = this.gastosNivel2[index]
        data.push({
          title: element.descricao,
          data: [
            {
              label: 'Valor Previsto',
              value: this.formatarMoeda(Number(element.vl_previsto))
            },
            {
              label: 'Valor Autorizado',
              value: this.formatarMoeda(Number(element.vl_autorizado))
            },
            {
              label: 'Empenhado',
              value: `${this.formatarMoeda(
                Number(element.vl_empenhado_acu)
              )} (${element.vl_empenhado_perc})`
            },
            {
              label: 'Liquidado',
              value: `${this.formatarMoeda(
                Number(element.vl_liquidado_acu)
              )} (${element.vl_liquidado_perc})`
            },
            {
              label: 'Pago',
              value: `${this.formatarMoeda(Number(element.vl_pago_acu))} (${
                element.vl_pago_perc
              })`
            }
          ]
        })
      }

      return data
    },
    loadGrupoDespesas(grupo_despesas) {
      const { descricao } = this.$route.params

      const filter = item => {
        if (item.chave.substring(0, descricao.length) === descricao) {
          return true
        }

        return false
      }

      this.items = grupo_despesas.filter(filter)

      if (!this.items.length) {
        this.$router.push('/despesas')
        return
      }

      this.title = _.first(this.items).descricao
    }
  }
}
</script>

<style scoped>
.totais-despesa {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-bottom: 15px;
}

ul > li {
  font-size: 1.2em;
}

.row .adiantamentos {
  display: flex;
  flex-flow: row wrap;
}

.row .adiantamentos .detalhes {
  align-self: center;
}

.lista-impar {
  background-color: #cccccc82;
}

.row .lista-head {
  font-weight: 600;
}

.row .lista-head,
.row .lista-body {
  padding: 5px 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/public/receitas_despesas/despesas/DetalheGrupoDespesa.vue